import * as tslib_1 from "tslib";
import { Logger } from '@services/logger/abstract.logger';
var DevLogger = /** @class */ (function (_super) {
    tslib_1.__extends(DevLogger, _super);
    function DevLogger() {
        return _super.call(this) || this;
    }
    Object.defineProperty(DevLogger.prototype, "log", {
        get: function () {
            return console.log.bind(console);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DevLogger.prototype, "warn", {
        get: function () {
            return console.warn.bind(console);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DevLogger.prototype, "error", {
        get: function () {
            return console.error.bind(console);
        },
        enumerable: true,
        configurable: true
    });
    return DevLogger;
}(Logger));
export { DevLogger };
